import axios from 'axios';
import { showErrorToast } from './toastUtils';

// Create axios instance with base URL
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api',
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error)) {
      // Handle 401 Unauthorized errors
      if (error.response?.status === 401) {
        // Clear local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Show error message with consistent ID
        showErrorToast(
          'Votre session a expiré. Veuillez vous reconnecter.',
          'session-expired',
          { position: 'top-center' }
        );
        
        // Redirect to login page
        window.location.href = '/login?expired=true';
        return Promise.reject(error);
      }
      
      // Handle other API errors
      const errorMessage = error.response?.data?.message || 'Une erreur est survenue';
      showErrorToast(
        errorMessage,
        `api-error-${Date.now()}`, // Use timestamp to avoid ID conflicts for different errors
        { position: 'top-center' }
      );
    } else {
      // Handle non-axios errors
      showErrorToast(
        'Une erreur de connexion est survenue',
        'connection-error',
        { position: 'top-center' }
      );
    }
    
    return Promise.reject(error);
  }
);

export default api; 